import React from "react";
import { useAuth } from "../contexts/AuthContext";
import { Navigate, useLocation } from "react-router-dom";
import Loading from "../Components/Common/Loading";

const ProtectedRoute = ({ children }) => {
  const { currentUser, loading } = useAuth();
  const location = useLocation();

  // Show loading while checking auth status
  if (loading) {
    return <Loading show={true} />;
  }

  /**
   * Go to login page if:
   * + No authenticated user
   * + User data fetched but no valid _id
   */
  if (!currentUser || !currentUser._id) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  /**
   * Redirect All protected page to account activate page if:
   * + Logged in, user status not activated
   */
  if (currentUser && currentUser.status !== "activated") {
    return <Navigate to="/account/activate" />;
  }

  // Continue the protect page if isAuthenticated
  return <>{children}</>;
};

export default ProtectedRoute;
